export default __webpack_public_path__ + "static/media/IMG_0007_15_11zon.1ea5c2df.jpg";